import type { TransactionHistoryProps } from './types';
import type { CreditTransaction } from '../../types/credits.types';

const transactionTypeStyles: Record<
  CreditTransaction['type'],
  { label: string; sign: string; color: string }
> = {
  addition: { label: '+ Addition', sign: '+', color: 'text-[#3fb950]' },
  deduction: { label: '- Deduction', sign: '-', color: 'text-[#da3633]' },
  reset: { label: '↺ Reset', sign: '-', color: 'text-[#d29922]' },
};

export const TransactionHistory = ({
  transactions,
}: TransactionHistoryProps) => {
  if (transactions.length === 0) {
    return (
      <div className="bg-[#161b22] border border-[#30363d] rounded-lg p-4 mb-4">
        <h2 className="text-sm text-[#8b949e] uppercase tracking-wide mb-3">
          Transaction History
        </h2>
        <p className="text-[12px] text-[#8b949e]">No transactions yet.</p>
      </div>
    );
  }

  return (
    <div className="bg-[#161b22] border border-[#30363d] rounded-lg p-4 mb-4">
      <h2 className="text-sm text-[#8b949e] uppercase tracking-wide mb-3">
        Transaction History
      </h2>

      <div className="max-h-[300px] overflow-y-auto">
        <table className="w-full text-[12px]">
          <thead>
            <tr className="text-[#8b949e] border-b border-[#30363d]">
              <th className="text-left py-1.5 px-2">Date</th>
              <th className="text-left py-1.5 px-2">Type</th>
              <th className="text-right py-1.5 px-2">Amount</th>
              <th className="text-left py-1.5 px-2">Description</th>
            </tr>
          </thead>
          <tbody>
            {transactions.map((transaction) => {
              const typeStyle = transactionTypeStyles[transaction.type];
              const formattedDate = new Date(
                transaction.createdAt,
              ).toLocaleString();

              return (
                <tr
                  key={transaction.id}
                  className="border-b border-[#21262d]"
                >
                  <td className="py-1.5 px-2 text-[#8b949e]">
                    {formattedDate}
                  </td>
                  <td className={`py-1.5 px-2 font-semibold ${typeStyle.color}`}>
                    {typeStyle.label}
                  </td>
                  <td className={`py-1.5 px-2 text-right font-bold ${typeStyle.color}`}>
                    {typeStyle.sign}{transaction.amount}
                  </td>
                  <td className="py-1.5 px-2 text-[#c9d1d9]">
                    {transaction.description || '—'}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};
